const TOKEN_KEY = 'qiyas_access_token';
const TENANT_KEY = 'qiyas_tenant_id';
const DEFAULT_TENANT_ID = '6b597961-7300-4000-8000-000000000001';

export function tenantFromJWT(): string | null {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.tenant_id || payload.tenant || null;
  } catch { return null; }
}

export function getAuthToken(): string | null {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}

export function getTenantId(): string {
  try {
    return localStorage.getItem(TENANT_KEY) || tenantFromJWT() || DEFAULT_TENANT_ID;
  } catch { return DEFAULT_TENANT_ID; }
}

export function injectAuthHeaders(headers: Record<string, any>): void {
  const token = getAuthToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  headers['X-Tenant-ID'] = getTenantId();
}
